import { createContext, useContext, useState, ReactNode } from "react";

type LetterType = "Settlement" | "Reservation of Rights" | "Denial" | "";

export type ClaimState = {
  letterType: LetterType;
  stateFilter: string;
  template: string;
  primaryCounsel: string | null;
  ccContacts: string[];
  serviceCompleted: boolean;
  bgTasksComplete: boolean;
  setLetterType: (v: LetterType) => void;
  setStateFilter: (v: string) => void;
  setTemplate: (v: string) => void;
  setPrimaryCounsel: (v: string | null) => void;
  setCcContacts: (v: string[]) => void;
  setServiceCompleted: (v: boolean) => void;
  setBgTasksComplete: (v: boolean) => void;
};

const ClaimContext = createContext<ClaimState | null>(null);

export function ClaimStateProvider({ children }: { children: ReactNode }) {
  const [letterType, setLetterType] = useState<LetterType>("Settlement");
  const [stateFilter, setStateFilter] = useState("All States");
  const [template, setTemplate] = useState("");
  const [primaryCounsel, setPrimaryCounsel] = useState<string | null>(null);
  const [ccContacts, setCcContacts] = useState<string[]>([]);
  const [serviceCompleted, setServiceCompleted] = useState(false);
  const [bgTasksComplete, setBgTasksComplete] = useState(false);

  return (
    <ClaimContext.Provider
      value={{
        letterType,
        stateFilter,
        template,
        primaryCounsel,
        ccContacts,
        serviceCompleted,
        bgTasksComplete,
        setLetterType,
        setStateFilter,
        setTemplate,
        setPrimaryCounsel,
        setCcContacts,
        setServiceCompleted,
        setBgTasksComplete,
      }}
    >
      {children}
    </ClaimContext.Provider>
  );
}

export function useClaimState() {
  const ctx = useContext(ClaimContext);
  if (!ctx) throw new Error("useClaimState outside provider");
  return ctx;
}
